import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "next-step"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "reaction-area" }
const _hoisted_6 = ["src", "alt", "onClick"]
const _hoisted_7 = { class: "tooltip" }
const _hoisted_8 = { class: "next-stat" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "step" }
const _hoisted_12 = ["onUpdate:modelValue", "onChange"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "count" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "damage" }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.toggleSwitch)
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_2, [
              _createElementVNode("legend", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSwitch = !_ctx.toggleSwitch))
              }, "  " + _toDisplayString(_ctx.displayName("NEXT STEP")) + "  ", 1),
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("select", {
                  class: "evaluation-item",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.evaluationItem) = $event)),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.evaluationItemOnChange && _ctx.evaluationItemOnChange(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.evaluationItemList, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: item
                    }, _toDisplayString(item.replace('.', ' ')), 9, _hoisted_4))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.evaluationItem]
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amplifyingReactionList, (reaction) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "reaction with-tooltip",
                      key: reaction
                    }, [
                      _createElementVNode("img", {
                        class: _normalizeClass('reaction' + (_ctx.selectedAmplifyingReaction == reaction ? ' selected' : '')),
                        src: _ctx.reactionImgSrc(reaction),
                        alt: reaction,
                        onClick: ($event: any) => (_ctx.reactionImgOnClick(reaction))
                      }, null, 10, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.displayName(reaction)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextStatRows, (row) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: row[0]
                    }, [
                      (row[3] || row[4])
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.displayName(row[0])), 1),
                            _createElementVNode("td", _hoisted_11, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((row[2]) = $event),
                                onChange: ($event: any) => (_ctx.nextStatStepOnChange(row))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row[1], (data, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: index
                                  }, _toDisplayString(Math.round(data * 10) / 10), 9, _hoisted_13))
                                }), 128))
                              ], 40, _hoisted_12), [
                                [_vModelSelect, row[2]]
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(Math.round(row[4] * 1000) / 1000 + '%'), 1),
                            _createElementVNode("td", _hoisted_14, [
                              _withDirectives(_createElementVNode("input", {
                                type: "range",
                                min: "-3",
                                max: "5",
                                "onUpdate:modelValue": ($event: any) => ((row[3]) = $event),
                                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextStatOnChange && _ctx.nextStatOnChange(...args)))
                              }, null, 40, _hoisted_15), [
                                [_vModelText, row[3]]
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.displayNextStatValue(row)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.isStop ? _ctx.displayName('停止中') : _ctx.displayName('稼働中')) + " ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stopButtonOnClick && _ctx.stopButtonOnClick(...args)))
                      }, _toDisplayString(_ctx.isStop ? _ctx.displayName('再開') : _ctx.displayName('停止')), 1)
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, null, -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetButtonOnClick && _ctx.resetButtonOnClick(...args)))
                      }, " Reset ")
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.containsDealMoreDamage) = $event)),
                          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.containsDealMoreDamageOnChange && _ctx.containsDealMoreDamageOnChange(...args)))
                        }, null, 544), [
                          [_vModelCheckbox, _ctx.containsDealMoreDamage]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.displayName('与えるダメージ')), 1)
                      ])
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("label", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleSwitch = !_ctx.toggleSwitch))
              }, _toDisplayString(_ctx.displayName("+ NEXT STEP +")), 1)
            ]))
      ]))
    : _createCommentVNode("", true)
}